<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="content-header-info pl-20">
            <div class="col-sm-11">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="javascript:void(0)">Fleet Master</a>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">Maintenance</li>
                </ol>
              </nav>
              <h2>Maintenance Report</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi dolorem
                facilis quia unde cum autem in amet. Hic, aut exercitationem! Fugit,
                veniam ad maxime obcaecati commodi sint corrupti. Esse, distinctio!
              </p>
            </div>
          </div>
        </div>
        <button class="btn btn-primary header-abso" @click="createItem()">
          &#43; Create New
        </button>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_length">
              <label
                >Show
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option v-for="item in table.pageSizes" :value="item" :key="item">
                    {{ item }}
                  </option>
                </select>
                entries</label
              >
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_filter pull-right">
              <label
                >Search:
                <input
                  type="search"
                  class="form-control"
                  v-model="table.keyword"
                  @keyup="onKeyupKeyword()"
              /></label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-accordion table-p15">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Vehicle</th>
                  <th class="text-center">Start Repaired</th>
                  <th class="text-center">End Repaired</th>
                  <th>Garage</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>
                    <strong>{{ item.plateNumber }}</strong>
                    {{ item.factoryName }} {{ item.brandName }}
                  </td>
                  <td class="text-center">{{ item.stringStartRepaired }}</td>
                  <td class="text-center">{{ item.stringEndRepaired }}</td>
                  <td>{{ item.garage }}</td>
                  <td class="text-center">{{ item.status }}</td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        class="btn btn-default"
                        type="button"
                        @click="viewDetail(item)"
                      >
                        <span class="sts-done">View</span>
                      </button>
                      <button
                        v-if="item.status === 'UnderMaintenance'"
                        class="btn btn-default"
                        type="button"
                        @click="updateItem(item)"
                      >
                        <span>Edit</span>
                      </button>
                      <button
                        v-if="item.status === 'UnderMaintenance'"
                        class="btn btn-default"
                        type="button"
                        @click="confirmDelete(item)"
                      >
                        <i class="ic-close"></i>
                      </button>
                      <button
                        v-if="item.status === 'UnderMaintenance'"
                        class="btn btn-default"
                        type="button"
                        @click="complete(item)"
                      >
                        <span>Done</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="vehiclemaintenancemodal">
      <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <h4>Maintenance</h4>
                  <h6>Please fill all information below.</h6>
                  <form role="form" action="#" id="vehicle-repairement-form">
                    <div class="form-group">
                      <label>Vehicle</label>
                      <select
                        class="form-control v-select"
                        name="vehicleId"
                        v-model="model.vehicleId"
                        :disabled="isEdit"
                        required
                      >
                        <option value>- Please Select -</option>
                        <option v-for="item in vehicles" :value="item.id" :key="item.id">
                          [{{ item.plateNumber }}] - {{ item.factoryName }}
                          {{ item.brandName }}
                        </option>
                      </select>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.vehicleId"
                        v-text="validationErrors.vehicleId"
                      ></small>
                    </div>

                    <div class="form-group" v-if="!isEdit">
                      <label>Start Repaired</label>
                      <VueCtkDateTimePicker
                        id="startRepaired"
                        v-model="model.startRepaired"
                        color="#025BC5"
                        format="YYYY-MM-DD"
                        formatted="LL"
                        overlay
                        auto-close
                        only-date
                        no-label
                        no-header
                        no-button
                        no-button-now
                      />
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.startRepaired"
                        v-text="validationErrors.startRepaired"
                      ></small>
                    </div>

                    <div class="form-group">
                      <label>Odometer</label>
                      <input
                        class="form-control"
                        type="text"
                        name="latestOdometer"
                        v-model="model.latestOdometer"
                        placeholder="Enter odometer"
                        maxlength="10"
                      />
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.latestOdometer"
                        v-text="validationErrors.latestOdometer"
                      ></small>
                    </div>

                    <div class="form-group">
                      <label>Garage</label>
                      <input
                        class="form-control"
                        type="text"
                        name="garage"
                        v-model="model.garage"
                        placeholder="Enter garage"
                        maxlength="100"
                      />
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.garage"
                        v-text="validationErrors.garage"
                      ></small>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-default"
                        @click.prevent="closeModal()"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        class="btn btn-primary"
                        @click.prevent="saveItem()"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <vehicleMaintenanceItemComponent></vehicleMaintenanceItemComponent>

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import deleteModal from "@/components/shared/DeleteModal";
import vehicleService from "@/services/master/vehicle/vehicleService.js";
import vehicleRepairementService from "@/services/master/repairement/vehicleRepairementService.js";
import vehicleMaintenanceItemComponent from "@/components/master/repairement/VehicleMaintenanceItem";

export default {
  components: {
    deleteModal,
    vehicleMaintenanceItemComponent,
  },
  computed: {
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      validationErrors: {
        startRepaired: null,
        vehicleId: null,
        garage: null,
        latestOdometer: null,
        status: null,
      },
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      itemToBeDeleted: null,
      isEdit: false,
      isDisplayRepairementItem: false,
      vehicles: [],
      items: [],
      detail: [],
      model: {},
      isLoading: false,
      msg: "Please wait",
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(publicSettings, "PageSize", 25);
    await this.getAll();
    await this.getVehicles();
  },
  mounted() {
    $(this.$refs.vehiclemaintenancemodal).on("hidden.bs.modal", this.closeModal);
  },
  updated() {
    this.$helper.collapseMenu("maintenance");
    this.$helper.setNavigationClass("maintenance-link");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    resetValidations() {
      this.validationErrors.startRepaired = null;
      this.validationErrors.vehicleId = null;
      this.validationErrors.garage = null;
      this.validationErrors.latestOdometer = null;
      this.validationErrors.status = null;
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.vehiclemaintenancemodal).modal();
    },
    closeModal() {
      this.resetValidations();
      this.model = {};
      $(this.$refs.vehiclemaintenancemodal).modal("hide");
    },
    async getAll() {
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await vehicleRepairementService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getVehicles() {
      this.vehicles = await vehicleService.getAllAvailable();
    },
    createItem() {
      this.isEdit = false;
      this.openModal({});
    },
    updateItem(item) {
      this.isEdit = true;
      this.openModal(item);
    },
    async saveItem() {
      if (!this.$helper.validateForm(this, "vehicle-repairement-form")) {
        return;
      }
      try {
        this.isLoading = true;
        const isUpdate = !!this.model.id;
        this.model.startRepairedCommand = this.$helper.fixDateTime(
          this.model.startRepaired
        );
        if (isUpdate) {
          await vehicleRepairementService.update(this.model);
          this.$notification.success("Successfully updated.", { title: "Success" });
        } else {
          await vehicleRepairementService.create(this.model);
          this.$notification.success("Successfully added.", { title: "Success" });
        }
        this.model = {};
        await this.getAll();
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await vehicleRepairementService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", { title: "Success" });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async complete(item) {
      try {
        this.isLoading = true;
        if (confirm("Are you sure you want to complete?")) {
          await vehicleRepairementService.complete(item.id);
          this.$notification.success("Successfully updated.", { title: "Success" });
          await this.getAll();
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    viewDetail(item) {
      this.isDisplayRepairementItem = true;
      // publish message
      this.$eventBus.$emit("initializeVehicleMaintenanceItem", item);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/repairement/VehicleMaintenance.vue